export default __webpack_public_path__ + "static/media/IUSD+.2c88d249.png";